function createOnDocLoad() {
  let isLoaded = false;
  const subscriptions = new Set();

  function subscribe(callback) {
    if (isLoaded) {
      callback();
      return;
    }

    subscriptions.add(callback);
  }

  function unsubscribe(callback) {
    subscriptions.delete(callback);
  }

  function notify() {
    subscriptions.forEach((callback) => {
      callback();
    });
  }

  function onLoad() {
    isLoaded = true;
    notify();
    destroy();
  }
  window.addEventListener('load', onLoad);

  function destroy() {
    window.removeEventListener('load', onLoad);
    subscriptions.clear();
  }

  return {
    subscribe,
    unsubscribe,
    destroy,
  };
}

export const {
  subscribe,
  subscribe: onDocLoad,
  unsubscribe,
  destroy,
} = createOnDocLoad();

export default {
  onDocLoad,
  subscribe,
  unsubscribe,
  destroy,
};

